import {Pipe, PipeTransform} from '@angular/core';
import {NgbTimeStruct} from "@ng-bootstrap/ng-bootstrap";
import {TranslocoService} from "@ngneat/transloco";

@Pipe({
    name: 'dateTimeInputFormatPipe'
})
export class DateTimeInputFormatPipe implements PipeTransform {

    constructor(private transloco: TranslocoService) {
    }

    transform(
        date: Date | undefined,
        options: {
            time?: NgbTimeStruct;
            displayTime?: boolean;
            displaySeconds?: boolean;
            displayMilliseconds?: boolean;
            milliseconds?: number;
            onlyYear?: boolean;
        } = {}
    ): string {
        if (!date) return '';

        const {
            time,
            displayTime = false,
            displaySeconds = false,
            displayMilliseconds = false,
            milliseconds = 0,
            onlyYear = false,
        } = options;

        const lang = this.transloco.getActiveLang() === 'en' ? 'en-GB' : this.transloco.getActiveLang()

        if (displayTime && time) {
            date.setHours(time.hour, time.minute, displaySeconds ? time.second : 0);
        }

        const formatOptions: Intl.DateTimeFormatOptions = onlyYear
            ? { year: 'numeric' }
            : {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                ...(displayTime && { hour: '2-digit', minute: '2-digit' }),
                ...(displaySeconds && { second: '2-digit' })
            };

        const value = date.toLocaleString([lang], formatOptions);

        return displayMilliseconds && !onlyYear
            ? `${value}.${milliseconds.toString().padStart(3, '0')}`
            : value;
    }

}
